import { EyeIcon, EyeOffIcon } from 'lucide-react'
import * as React from 'react'

import { cn } from '@/utils/cn'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
    const [type, setType] = React.useState(props.type)

    const cmp = (
        <input
            className={cn(
                'placeholder:text-muted-foregrund flex h-10 w-full rounded-md border border-border bg-input px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                className && { [className]: props.type !== 'password' },
            )}
            ref={ref}
            {...props}
            type={type}
        />
    )

    if (props.type === 'password') {
        const Icon = type === 'password' ? EyeIcon : EyeOffIcon
        return (
            <div className={cn('flex gap-4 items-center', className)}>
                {cmp}
                <Icon
                    className="w-4 h-4 mr-2 cursor-pointer hover:text-primary"
                    onClick={() => setType(type === 'password' ? 'text' : 'password')}
                />
            </div>
        )
    }

    return cmp
})
Input.displayName = 'Input'

export { Input }
